export default {
  "Connect Wallet": "Подключить кошелек",
  "Loading":"Загрузка...",
  "Purchase Quantity": "Количество покупки",
  "Total Amount": "Общая сумма",
  "Payment Method": "Способ оплаты",
  "Fee": "Комиссия",
  "Purchase": "Купить",
  "Select Payment Method": "Выберите способ оплаты",
  "Language Switch": "Смена языка",
  "Mall": "Магазин",
  "STAR Purchase": "Покупка STAR",
  "Order Details": "Детали заказа",
  "My Orders": "Мои заказы",
  "Order Confirmation Page": "Страница подтверждения заказа",
  "Product Details": "Детали товара",
  "Store Details": "Детали магазина",
  "Staking MUSE":"Стейкинг MUSE",
  "My Stake":"Мой стейкинг",
  "Redeemable Time":"Время выкупа",
  "Redeem":"Выкупить",
  "Stake":"Стейк",
  "How to Obtain MUSE":"Как получить MUSE",
  "Activity Rules":"Правила активности",
  "Stake Amount":"Сумма стейкинга",
  "Please Enter Amount":"Введите количество",
  "Balance":"Баланс",
  "Redeem Amount":"Сумма выкупа",
  "Confirm":"Подтвердить",
  "Cancel":"Отмена",
  "Staking MUSE can increase the voting power for activities on the StarNest platform, allowing you to vote for your favorite participants.":"Стейкинг MUSE может увеличить количество голосов для активности на платформе StarNest, позволяя голосовать за любимых участников.",
  "Rule1":"1. Через стейкинг MUSE увеличивается вес голосов в активности платформы StarNest (см. описание конкретной активности).",
  "Rule2":"2. Стейкинг MUSE можно выкупить в любое время после окончания активности.",
  "Rule3":"3. Стейкинг MUSE также позволяет участвовать в управлении платформой и других активностях.",
  "Rule4":"4. Окончательное право толкования принадлежит платформе StarNest.",
  "Staked":"Застейкано",
  "Redeemed":"Выкуплено",
  "Payment":"Оплата",
  "Next step":"Следующий шаг",
  "Amount":"Сумма",
  "Copied":"Скопировано",
  "QRCodeTip":"Пожалуйста, отсканируйте QR-код или скопируйте адрес для оплаты заказа. Если сумма оплаты недостаточна, заказ не будет выполнен, и возврат не предусмотрен.",
  "Scan QR code to pay":"Сканируйте QR-код для оплаты",
  "DownloadTip":"Сканируйте для загрузки приложения StarNest и сразу начните пользоваться",
  "Save QR code":"Сохранить QR-код",
  "Minimum":"Минимум",
  "All":"Все",
  "Failed to create order":"Не удалось создать заказ",
  "The order was created successfully and payment is being redirected":"Заказ успешно создан, идет перенаправление на оплату",
  "Payment details":"Детали оплаты",
  "Address management":"Управление адресами",
  "New address":"Новый адрес",
  "Delete address":"Удалить адрес",
  "Are you sure you want to delete this address?":"Вы уверены, что хотите удалить этот адрес?",
  "First name":"Фамилия",
  "Last name":"Имя",
  "Please enter":"Пожалуйста, введите",
  "Phone":"Телефон",
  "Country":"Страна/регион",
  "State/Province":"Штат/провинция",
  "City":"Город",
  "Address":"Адрес",
  "Zip code":"Почтовый индекс",
  "Email":"Эл. почта",
  "Save address":"Сохранить адрес",
  "The address has been edited, do you want to save it?":"Адрес был изменен, хотите сохранить?",
  "Return":"Назад",
  "Save":"Сохранить",
  "Waiting for payment":"Ожидание оплаты",
  "Please complete the payment within time as soon as possible":"Пожалуйста, завершите оплату в течение {time} как можно скорее",
  "Expired":"Истек",
  "Order ID":"ID заказа",
  "Order total":"Итого заказа",
  "Order time":"Время заказа",
  "Payment method":"Способ оплаты",
  "Billing address":"Платежный адрес",
  "Switch address":"Сменить адрес",
  "Pay":"Подтвердить оплату",
  "Deleted":"Удалено",
  "Please fill in the form completely":"Пожалуйста, полностью заполните форму",
  "Create success":"Успешно создано",
  "Update success":"Успешно обновлено",
  "Insufficient balance":"Недостаточный баланс",
  "No address filled in yet":"Адрес еще не заполнен",
  "Choose country":"Выберите страну",
  "Please enter search keywords":"Введите ключевые слова для поиска",
  "Payment successful":"Оплата успешна",
  "Please check the balance in your wallet":"Проверьте баланс в кошельке",
  "Finish":"Готово",
  "Payment failed":"Ошибка оплаты",
  "Please complete the payment in time in My Order-Waiting for Payment":"Пожалуйста, вовремя завершите оплату в Мои заказы - Ожидает оплаты",
  "Verification": "Пожалуйста, пройдите проверку безопасности",
  "Slide": "Сдвиньте вправо для завершения проверки",
  "Point": "Пожалуйста, нажмите по порядку",
  "Verify success": "Проверка успешна",
  "Verify fail": "Проверка не удалась",
  "Uploading":"Загрузка",
  "Upload payment voucher":"Загрузить подтверждение оплаты",
  "Submission successful, please check the order later":"Отправка успешна, проверьте заказ позже",
  "Confirm submission":"Подтвердить отправку",
  "Detail":"Детали",
  "Rate tip":"В зависимости от способа оплаты цена может различаться из-за курсов валют. Окончательная сумма определяется при оплате.",
  "Please log in":"Пожалуйста, войдите",
  "Insufficient product inventory":"Недостаточный запас товара",
  "Showtime":"Сеанс",
  "Ticket file":"Тип билета",
  "Sold out":"Продано",
  "Limit tickets per order":"Максимум {num} билетов за заказ",
  "Please select region":"Пожалуйста, выберите регион",
  "Please fill in the correct email address":"Пожалуйста, введите правильный email адрес",
  "Delivery method":"Способ доставки",
  "E-ticket":"Электронный билет",
  "Direct entry":"Прямой вход",
  "After payment is successful, no need to pick up the ticket, go to the ticket folder to check the admission voucher":"После успешной оплаты билет не нужно забирать, перейдите в папку билетов, чтобы проверить пропуск",
  "Contact person":"Контактное лицо",
  "Name":"Имя",
  "Please fill in the contact name":"Пожалуйста, введите имя контакта",
  "Region":"Регион",
  "Please enter the mobile number":"Пожалуйста, введите номер телефона",
  "Please fill in the email":"Пожалуйста, введите email",
  "The ticket verification code will be sent to your email via":"Код проверки билета будет отправлен на вашу электронную почту",
  "Details":"Подробности",
  "Submit order":"Отправить заказ",
  "Price details":"Детали цены",
  "The actual discount amount is subject to the following single page":"Фактическая сумма скидки определяется на странице заказа",
  "Product information":"Информация о товаре",
  "STAR deduction":"Списание STAR",
  "Credit Card":"Кредитная карта",
  "Payment Platform":"Платежная платформа",
  "On-Chain Payment":"Оплата в блокчейне",
  "Other":"Другое",
  "No refunds":"Возврат не предусмотрен",
  "Transferable":"Можно передавать",
  "Not transferable":"Нельзя передавать",
  "Ended":"Завершено",
  "Countdown":"Обратный отсчет",
  "Please select the ticket file":"Пожалуйста, выберите тип билета",
  "Insufficient commodity inventory":"Недостаточный товарный запас",
  "Please go to log in":"Пожалуйста, войдите",
  "Integral Mall":"Магазин баллов",
  "All Products":"Все товары",
  "Integral Records":"История баллов",
  "Transaction Details":"Детали транзакции",
  "what":"Что такое MUSE?",
  "museIntro":"MUSE — это токен ARC20, выпущенный в Armonia Meta Chain, с общим объемом эмиссии 2,1 млрд. 80% токенов MUSE добываются через экосистемный майнинг.",
  "museUse":"Для чего используется MUSE?",
  "copyrightStaking":"Стейкинг авторских прав",
  "copyrightStaking1":"Стейкинг MUSE в авторские NFT (метавселенная AI, портреты, аудио/видео и др.) артистов-партнеров, деление доходов от авторских прав.",
  "vote":"Голосование на конкурсах",
  "vote1":"Стейкинг MUSE дает дополнительные голоса в STAR NEST WAR и участие в голосовании на всех этапах конкурса.",
  "product":"Покупка продуктов",
  "product1":"Используется для покупки специальных продуктов экосистемы, таких как ограниченные NFT артистов, мерч, билеты (ранний доступ, VIP и др.).",
  "more":"Больше возможностей (обновляется)",
  "more1":"Игровая экосистема: лицензированные игры могут использовать авторские права артистов, а товары оплачиваются MUSE.",
  "more2":"Поддержка артистов: MUSE можно использовать для донатов артистам и авторам музыки.",
  "activity":"Специальные мероприятия",
  "activity1":"Получите приглашение на определенные мероприятия.",
  "how":"Как получить MUSE?",
  "how1":"Через участие в ранних приватных продажах MUSE.",
  "how2":"Через создание контента, когда пользователи вознаграждают авторов.",
  "how3":"Через участие в мероприятиях (покупка билетов, покупки в магазине, оффлайн-активности) и получение аирдропа.",
  "how4":"Слушайте/смотрите некоторые работы Audition и зарабатывайте одновременно",
  "Redeem now":"Обменять сейчас",
  "Basic information":"Основная информация"
}
